import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import styles from "assets/css/modals.module.css";
import View from "components/TargetGroup/View";
import { Form, Formik } from "formik";
import AppButton from "components/AppButton/AppButton";

function Groups(props) {
  const {
    isVisible,
    hideAddGroupButton,
    groupViewProps = {},
    btnLabel = "Select",
    allowEmptyGroup = false,
    handleCancel,
    selectType = "radio",
    handleGroupSelect,
    group,
    groupObj,
    heading = "Select Your Group"
  } = props;

  const [selectedGroups, setSelectedGroups] = useState(group || []);
  const [selectedGroupObjects, setSelectedGroupObjects] = useState(groupObj || []);

  useEffect(() => {
    if (isVisible) {
      setSelectedGroups(group || []);
      setSelectedGroupObjects(groupObj || []);
    }
  }, [isVisible, group, groupObj]);

  return (
    <Modal
      destroyOnClose
      centered
      title={
        <div className="text-center">
          <h4 className="pt-3 fw-bold">{heading}</h4>
        </div>
      }
      closeIcon={
        <div className={`btn ${styles.modalCloseBtn}`}>
          <i className="fas fa-times"></i>
        </div>
      }
      visible={isVisible}
      onCancel={handleCancel}
      width={800}
      footer={null}
      maskStyle={{
        background: "linear-gradient(135deg, #00000050, #107c9850)"
      }}
      bodyStyle={{
        paddingTop: "0px"
      }}
    >
      <Formik
        enableReinitialize={true}
        initialValues={{
          group: selectedGroups,
          groupObj: selectedGroupObjects
        }}
        onSubmit={(values, { setSubmitting }) => {
          // Pass the selected values to parent
          handleGroupSelect({
            group: values.group,
            groupObj: values.groupObj
          });
          setSubmitting(false);
        }}
      >
        {({ values, setFieldValue, handleSubmit, isSubmitting }) => (
          <Form onSubmit={handleSubmit} className="text-center">
            <View
              selectType={selectType}
              campaign
              setFieldValue={setFieldValue}
              campaignGroup={values.group}
              campaignGroupObj={values.groupObj}
              smallSize={false}
              {...groupViewProps}
              hideAddGroupButton={hideAddGroupButton}
            />
            <AppButton label={btnLabel} type="submit" light disabled={(values.groupObj && values.groupObj.status === "Queued" && !allowEmptyGroup) || isSubmitting} isSubmitting={isSubmitting} />
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

export default Groups;
